import { Controller } from "@hotwired/stimulus"

// "Edit in <tree>" on a contact panel.
//
// The panel is usually open BESIDE the tree, so the href reloaded the very page
// you were already looking at in order to open a modal on it - a full navigation
// to arrive two inches to the left. On the tree, ask the tree; anywhere else
// (the network list, a contact's own page) the href is the right answer and is
// left alone, which also keeps middle-click and copy-link working everywhere.
export default class extends Controller {
    static values = { personId: String }

    open(event) {
        if (!document.querySelector("[data-controller~='contact-tree']")) return
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return

        event.preventDefault()
        document.dispatchEvent(new CustomEvent("family-tree:edit-person", { detail: { personId: this.personIdValue } }))
    }
}
